import {
    getVideo,
    addVideo,
    editVideo,
    deleteVideo,
    editVideoStatus
} from '@/api/VideoController'
import { getCategory } from '@/api/CategoryController'
import { Message } from 'element-ui'
import common from '@/utils/common'

const video = {
  namespaced: true,
  state: {
    dataDialogVisible: false,
    categoryList: [],
    pageLoading: true,
    listQuery: {
      params: {
        pageSize: common.pagination.pageSize,
        pageNum: 1
      },
      data: {}
    },
    editData: {
      id: '',
      name: '',
      type: '',
      videoUrl: '',
      startTime: '',
      endTime: '',
      sort: '',
      note: ''
    },
    dataList: {
      total: 0
    }
  },
  mutations: {
    UPDATE_STATE: (state, data) => {
      state[data.key] = data.val
    },
    SET_LIST_QUERY: (state, query) => {
      Object.keys(query).forEach((key) => {
        state.listQuery.params[key] = query[key]
      });
    },
    SET_EDIT_OBJ: (state, data) => {
      Object.keys(data).forEach((key) => {
        state.editData[key] = data[key]
      })
    },
    SET_EDIT: (state, data) => {
      state.editData[data.key] = data.val
    },
    SET_EDIT_DEFAULT: (state) => {
      Object.keys(state.editData).forEach(key => {
        state.editData[key] = ''
      })
    }
  },
  actions: {
    GetCategoryList(context) {
      return new Promise((resolve, reject) => {
        getCategory('video').then(res => {
          let arr = res.data
          let newArr = Object.keys(arr).map(key => {
            return { value: arr[key].id, label: arr[key].name }
          })
          context.commit('UPDATE_STATE', { key: 'categoryList', val: newArr })
        }).catch(err => {
          Message.error(err.response.data.message)
        })
      })
    },
    TriggerStatus(context, data) {
      return new Promise((resolve, reject) => {
        editVideoStatus(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetList(context) {
      return new Promise((resolve, reject) => {
        context.commit('UPDATE_STATE', { key: 'pageLoading', val: true })
        getVideo(context.state.listQuery).then(res => {
          context.commit('UPDATE_STATE', { key: 'pageLoading', val: false })
          context.commit('UPDATE_STATE', { key: 'dataList', val: res.data })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Add(context) {
      return new Promise((resolve, reject) => {
        addVideo(context.state.editData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Edit(context) {
      return new Promise((resolve, reject) => {
        editVideo(context.state.editData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Delete(context, data) {
      return new Promise((resolve, reject) => {
        deleteVideo(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default video
